import React, {FunctionComponent} from 'react';
import {Title} from '@treez-ui/core/layout';
import {TitleSize} from '@treez-ui/core/layout/Title';
import {ProductPreviewPanel} from '@treez-ui/core/modules/brandtreez/ProductPreviewPanel';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';

interface Props {
    productToLink: Partial<ProductInCatalog>;
}

export const LinkProductHeader: FunctionComponent<Props> = ({productToLink}: Props) => {
    return (
        <div className="link-product-header">
            <div className="link-title-header-container">
                <Title size={TitleSize.LARGE} text="Product To Link" />
            </div>
            {productToLink && <ProductPreviewPanel product={productToLink} />}
        </div>
    );
};

export default LinkProductHeader;
